import { Schedule } from "../../../entities";
import { BaseDataRepository } from "../../BaseDataRepository";
export class ScheduleRepo extends BaseDataRepository<Schedule> {
  protected baseUrl = 'schedule';

  async getDefaultSchedulesAsync(providerId: number): Promise<Schedule[]> {
    const response = await this.client.get(`${this.baseUrl}/default/${providerId}`);
    return this.handleResponse<Schedule[]>(response)!;
  }

  async getExceptionSchedulesAsync(providerId: number): Promise<Schedule[]> {
    const response = await this.client.get(`${this.baseUrl}/override/${providerId}`);
    return this.handleResponse<Schedule[]>(response)!;
  }

  async setScheduleBlocksAsync(scheduleId: number, scheduleBlocks: any): Promise<void> {
    const response = await this.client.post(`${this.baseUrl}/${scheduleId}/blocks`, scheduleBlocks);
    return this.handleResponse<void>(response)!;
  }

  async cloneAsync(id: number, effectiveDate: Date): Promise<number> {
    const response = await this.client.post(`${this.baseUrl}/${id}/clone`, effectiveDate);
    return this.handleResponse<number>(response)!;
  }

  async createScheduleAsync(schedule: Schedule): Promise<Schedule> {
    const response = await this.client.post(`${this.baseUrl}/createSchedule`, schedule);
    return this.handleResponse<Schedule>(response)!; 
  }

  async deleteScheduleAsync(scheduleId: number) : Promise<void> {
    const response = await this.client.delete(`${this.baseUrl}/deleteSchedule/${scheduleId}`);
    return this.handleResponse<void>(response)!; 
  }

  async getUserSchedulesAsync(userId: number): Promise<Schedule[]> {
    const response = await this.client.get(`${this.baseUrl}/getUserSchedules/${userId}`);
    return this.handleResponse<Schedule[]>(response)!;
  }

  async getSchedulesByProviderIdsAsync(providerIds: string): Promise<Schedule[]> {
    const response = await this.client.get(`${this.baseUrl}/getSchedulesByProviderIds?providerIds=${providerIds}`);
    return this.handleResponse<Schedule[]>(response)!;
  }

}

export default ScheduleRepo;
